import React from 'react';
import styled from 'styled-components';
import Flatpickr from 'react-flatpickr';
export const StyledFlatpickr = /*#__PURE__*/React.memo(styled(Flatpickr).withConfig({
  displayName: "Flatpickr__StyledFlatpickr",
  componentId: "sc-1xgn43s-0"
})(["font-size:1rem;&&:focus,&&:active{outline:none;border:2px solid ", ";}&&:hover{border-color:", ";}"], props => props.theme.palette.primary.main, props => props.theme.palette.action.active));
export default StyledFlatpickr;